export default {"src":"/_next/static/media/nftfy-white.d78117cf.svg","height":44,"width":129};